<template>
  <div
    class="Overlay"
    data-action="close-modal"
    @click.self="closeModal"
  >
    <div class="ModalBox ModalBox--central ModalBox--400">
      <div class="ModalBox-header d-flex justify-content-between align-items-center p-3">
        <button
          class="Fuell-IconButton Fuell-IconButton--no-margin Fuell-IconButton--close"
          @click="closeModal"
        >
          <img
            class="Fuell-IconButton--close-img"
            :src="require('@/assets/img/icons/close.svg')"
            alt="Close"
          />
        </button>
        <div
          class="Tit Tit--modal w-100"
          v-t="{ path: 'customer_action_transfer' }"
        ></div>
      </div>
      <div class="ModalBox-container position-relative pl-3 pr-3 pt-3 pb-3 mt-5">
        <div class="col-12">
          <input-file
            v-if="!transferData.file"
            id="inputFile"
            ref="inputFileComponent"
            alternateTemplate
            @change="manageReceipt"
          >
            <span
              class="add-receipt-button mt-2"
              aria-labelledby="add receipt"
            >
              <img alt="icon-add-receipt" :src="require('@/assets/img/icons/icon-add.svg')" />
              <span class="add-receipt-button--text">{{ $t ('ACTION_ADD_RECEIPT').toUpperCase() }}</span>
            </span>
          </input-file>
          <span v-else>
            {{transferData.file.name}}
          </span>
        </div>
        <div class="col-12">
          <div class="input--block input--block--margin input--block--padded">
            <label
              for=""
              class="form--label u-required"
            >{{ $t ('customer_amount_to_transfer').toUpperCase() }}</label>
            <div
              class="Form-field"
              :class="{'input--error' : $v.transferData.amount.$error}"
            >
              <currency-input
                :class="'Input-text'"
                :allow-negative="false"
                :placeholder="$t('customer_amount_to_transfer')"
                @blur="$v.transferData.amount.$touch()"
                v-model="transferData.amount"
              ></currency-input>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="input--block input--block--margin input--block--padded">
            <label
              for=""
              class="form--label u-required"
            >
              {{ $t ('customer_transfer_concept').toUpperCase() }}
            </label>
            <div
              class="Form-field"
              :class="{'input--error' : $v.transferData.concept.$error}"
            >
              <input
                type="text"
                name=""
                id=""
                class="Input-text"
                :placeholder="$t('customer_transfer_concept')"
                @blur="$v.transferData.concept.$touch()"
                v-model.trim="transferData.concept"
              >
            </div>
          </div>
        </div>
        <div class="col-12 mt-3">
          <div class="input--block input--block--margin input--block--padded">
            <label
              for=""
              class="form--label u-required"
            >{{ $t ('PASSCODE').toUpperCase() }}</label>
            <div
              class="Form-field"
              :class="{'input--error' : $v.transferData.passcode.$error}"
            >
              <input
                type="password"
                class="Input-text"
                :placeholder="$t('PASSCODE')"
                autocomplete="new-password"
                @blur="$v.transferData.passcode.$touch()"
                v-model="transferData.passcode"
              >
            </div>
          </div>
        </div>
        <div class="col-12 d-flex justify-content-center my-4">
          <button
            v-if="!isCallingApi"
            @click="showConfirmModal"
            :disabled="!canBeSubmitted && !isCallingApi"
            class="Fuell-Button block blue"
          >{{$t('ACTION_SEND')}}</button>
          <div
            class="d-flex flex-column justify-content-center"
            v-else
          >
            <div class="mx-auto">
              <Spinner />
            </div>
            <span>{{$t('ACTION_SENDING')}}</span>
          </div>
        </div>
      </div>
    </div>
    <confirm-modal
      :open.sync="showConfirmModalFlag"
      @dismiss="closeModal"
      @accept="submitTransfer"
      v-if="showConfirmModalFlag"
      :title="'customer_action_transfer'"
      :acceptText="'customer_action_transfer'"
    ></confirm-modal>
  </div>
</template>

<script>
import customersApi from '../../_api'

import _modalHandlerMixin from '@/components/Commons/_mixins/_modalHandlerMixin'
import { CurrencyInput } from 'vue-currency-input'
import Spinner from '@/components/Commons/Spinner'
import InputFile from '@/components/Commons/Forms/InputFile'
const { validationMixin } = require('vuelidate')
const { required } = require('vuelidate/lib/validators')
const ConfirmModal = () => import('@/components/Commons/ConfirmModal')

export default {
  name: 'CustomerFundsTransferModal',
  mixins: [_modalHandlerMixin, validationMixin],
  components: {
    CurrencyInput,
    Spinner,
    ConfirmModal,
    InputFile
  },
  props: {
    customer: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      transferData: {
        amount: null,
        passcode: null,
        concept: null,
        file: null
      },
      isCallingApi: false,
      showConfirmModalFlag: false
    }
  },
  computed: {
    canBeSubmitted () {
      return !this.$v.$invalid
    },
    loggedUserId () {
      return this.$store.getters['LoginStore/user'].id || false
    }
  },
  methods: {
    manageReceipt (event) {
      this.transferData.file = event
    },
    showConfirmModal () {
      this.showConfirmModalFlag = true
    },
    replaceDots () {
      this.iban = this.iban.split('.').join('')
    },
    async submitTransfer () {
      try {
        if (this.isCallingApi) return
        this.isCallingApi = true
        let transferData = new FormData()
        transferData.append('file', this.transferData.file)
        transferData.append('amount', this.transferData.amount)
        transferData.append('concept', this.transferData.concept)
        transferData.append('passcode', this.transferData.passcode)

        await customersApi.postTransferCustomer(this.customer.id, transferData)

        this.$store.dispatch('SnackBars/addSuccess', this.$t('customers_bill_client_success'), { root: true })
        this.closeModal()
      } catch (error) {
        this.$store.dispatch('SnackBars/addErrorHandler', { error: error, errorMessage: 'customers_bill_client_error' }, { root: true })
      } finally {
        this.isCallingApi = false
      }
    }
  },
  validations: {
    transferData: {
      amount: { required },
      passcode: { required },
      concept: { required }

    }
  }
}
  </script>
